import { IonIcon } from '@ionic/react';
import { warningOutline } from 'ionicons/icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useStoreActions, useStoreState } from '../store';
import './StormBanner.css';

const StormBanner: React.FC = () => {
  const alert = useStoreState((s) => s.storm.alert);
  const incrementReopenSignal = useStoreActions((a) => a.storm.incrementReopenSignal);

  if (!alert || alert.state === 'none') return null;

  const handleClick = (): void => {
    incrementReopenSignal();
  };

  return (
    <button
      type="button"
      className={`storm-banner storm-banner-${alert.state}`}
      onClick={handleClick}
      aria-label="Reopen storm alert"
    >
      <IonIcon icon={warningOutline} className="storm-banner-icon" />
      <span className="storm-banner-text">
        <FormattedMessage id={`storm.banner.${alert.state}`} />
      </span>
    </button>
  );
};

export default StormBanner;
